// extracted by mini-css-extract-plugin
export default {"awards":"awards_awards__tNHVK","infiniteScrollDiv":"awards_infiniteScrollDiv__c62Ye"};